import { render, staticRenderFns } from "./UsageTermsCreate.vue?vue&type=template&id=5a46c952&scoped=true"
import script from "./UsageTermsCreate.vue?vue&type=script&lang=js"
export * from "./UsageTermsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a46c952",
  null
  
)

export default component.exports